module.exports = __webpack_public_path__ + "img/monitor-selector.9f8515b2.svg";